import React from "react";
import PropTypes from "prop-types";
import {
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText,
} from "@material-ui/core";
import { useTranslations } from "adapters/i18n";

export const DialogAtualizacaoRetiroPasto = (props) => {
  const { ExcluirModuloAlterandoRetiro } = props;
  const { t } = useTranslations();

  return ExcluirModuloAlterandoRetiro ? (
    <Dialog
      id="excluirModuloAlterandoRetiro"
      open={ExcluirModuloAlterandoRetiro}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      onClose={() => props.handleFechaConfirmarExclusaoModulo()}
    >
      <DialogTitle id="alert-dialog-modal-exclusao-modulo-retiro-title">
        {t("pasture:confirm-module-deletion")}
      </DialogTitle>
      <DialogContent id="alert-dialog-description">
        <DialogContentText>
          {t("pasture:module-deletion-description")}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          id="botaoCancelar"
          onClick={() => props.handleFechaConfirmarExclusaoModulo()}
          color="primary"
          autoFocus
          style={{ textTransform: "uppercase" }}
        >
          {t("common:actions.cancel")}
        </Button>
        <Button
          id="botaoConfirmar"
          onClick={() => props.handleConfirmarExclusaoModuloAlterandoRetiro()}
          color="primary"
          style={{ textTransform: "uppercase" }}
        >
          {t("common:actions.confirm")}
        </Button>
      </DialogActions>
    </Dialog>
  ) : null;
};

DialogAtualizacaoRetiroPasto.propTypes = {
  ExcluirModuloAlterandoRetiro: PropTypes.bool.isRequired,
  handleFechaConfirmarExclusaoModulo: PropTypes.func.isRequired,
  handleConfirmarExclusaoModuloAlterandoRetiro: PropTypes.func.isRequired,
};

export default DialogAtualizacaoRetiroPasto;
